import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

const toggleAccordion = {
  paddingBottom: {
    iphone: 24,
  },
};

const openedToggleAccordion = {
  paddingBottom: {
    iphone: 16,
  },
};

const openedToggleAccordionIcon = {
  transform: {
    iphone: `translateY(calc(-50% + ${
      (toggleAccordion.paddingBottom.iphone -
        openedToggleAccordion.paddingBottom.iphone) /
      2
    }px)) rotate(180deg)`,
  },
};

const toggleAccordionIcon = {
  transform: {
    iphone: 'translateY(-50%)',
  },
};

export const ReportDetailsStyle = styled.div`
  background-color: ${colors.mostlyWhite};
  border-radius: 12px;

  &.details-content-accordion {
    &.opened {
      .toggle-accordion {
        padding: 24px 60px ${openedToggleAccordion.paddingBottom.iphone}px 20px;

        .icon {
          transform: ${openedToggleAccordionIcon.transform.iphone};
        }
      }

      .accordion-contents {
        max-height: 99em;
        opacity: 1;
        transform: translateY(0);
      }
    }

    .toggle-accordion {
      ${fontFamily.sourceSansPro.bold}
      color: ${colors.veryDarkGrayishBlue};
      font-size: 14px;
      line-height: 18px;
      padding: 24px 60px ${toggleAccordion.paddingBottom.iphone}px 20px;
      position: relative;
      text-align: left;
      transition: padding 300ms;
      width: 100%;

      .icon {
        display: block;
        height: 20px;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: ${toggleAccordionIcon.transform.iphone};
        transition: transform 300ms;
        width: 20px;

        svg {
          display: block;
          fill: ${colors.veryDarkGray};
          height: auto;
          width: 100%;
        }
      }
    }

    .accordion-contents {
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      transform: translateY(-24px) rotate(0);
      transition: max-height 300ms, opacity 300ms, transform 200ms;
    }
  }

  &.details-content-static {
    background-color: transparent;

    .toggle-accordion {
      display: none;
      transition: none;

      .icon {
        transition: none;
      }
    }

    .accordion-contents {
      transition: none;
    }
  }

  .accordion-contents {
    .exam-content {
      @media (min-width: ${breakpoints.ipad.width}px) {
        margin-bottom: 24px;
      }
    }
  }
`;
